<template>
  <div>
    <div id="homeMap" class="home-map" :style="`left: ${distance};`"></div>
    <SearchAddress :map="bmap" />
    <z-info-box ref="infoBox" @showDetail="showDetail" @showTrack="showTrack" @clearOverlay="clearOverlay"
      @clearFences="clearFences" @openedInfoBoxId="openedInfoBoxId" @closeDetail="onCloseDetail"></z-info-box>
    <CheckFenceGroup v-if="showFenceCheck" :checkList="checkFenceData" @checkOk="onCheckOk" />
    <LeafPolygon :data="currentScene" :mapUrl="currentSceneMap" :mapBounds="imageBounds" :areaBounds="areaBounds" :optType="optType"
      :areaName="areaName" :personLimit="personLimit" :areaType="areaType" :floorName="floorName" @polygon-msg="getPolygonMsg" @polygon-del="delArea"
       v-if="showPolygonSet" ref="lefPolygonSet" :draw-marker="drawMarker">
    </LeafPolygon>
    <div class="area-map-border" v-if="selectInNode">
      <div class="area-map" id="areaMap"></div>
      <div class="cancelBtn" @click="cancelModal">X</div>
      <a-button id="custom-button-line" @click="handleLineBtn">{{ switchLine ? '取消' : '轨迹画线' }}</a-button>
      <a-button id="custom-button-count" @click="handleCountBtn">区域绘制</a-button>
      <a-select id="custom-select-person"  placeholder="请选择区域"  mode="multiple" @change="handleSelectChange"> 
        <a-select-option v-for="item in areaList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
      </a-select>
      <a-button id="custom-button-person" @click="handlePersonBtn" type="primary">人员统计</a-button>
      <a-modal
        title="人员统计结果"
        :visible="showPersonStatistics"
        width="600px" 
        :footer="null"
        @cancel="showPersonStatistics = false"  
             >
        <a-table :columns="personStatisticsColumns" :data-source="personStatistics" :pagination="false" />
      </a-modal>
    </div>
  </div>
</template>
<script>
import config from '@/config'
import ZInfoBox from '@/views/home/InfoBox.vue'
import CheckFenceGroup from '../../components/FenceDrawer/checkFenceGroup'
import SearchAddress from '../../components/BMapComponents/SearchAddress'
import { mapState, mapActions } from 'vuex'
import {
  MarkerClusterer
} from '@assets/js/MarkerClusterer'
import iconNormalImg from '@assets/images/marker_normal_icon.png'
import iconAlarmImg from '@assets/images/marker_alarm_icon.png'
import iconOfflineImg from '@assets/images/marker_offline_icon.png'
import iconOfflineAlarmImg from '@assets/images/marker_offline_alarm_icon.png'
import {
  TransForm
} from '@/assets/js/transform.js'
import bus from '../../bus/bus'
import MapInitControl from '../../utils/setMapInit'
import MarkerLabelControl from '../../utils/mapControls/markerLabelControl'
import OrgFenceControl from '../../utils/mapControls/orgFenceControl'
import { markerLabelStyle, notAllowedInFenceStyle, notAllowedOutFenceStyle } from '../../config/globalConfig'
import { httpModel } from '../../http/httpModel'
import { drawFence } from '../../model/drawFence'
import { transToBD09 } from '../../utils/globalFunction'
import LeafPolygon from '../../components/common/leafPolygon.vue'

import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.pm";
import "leaflet.pm/dist/leaflet.pm.css";
import MovingMarker from "@/utils/movingMarker";
import state from '../../vuex/state'
import log from '../../lang/logs/log-cn'

// 节流eg
// showInfo: _.throttle(, 3000, {leading: true})

export default {
  name: 'ZHomeMap',
  props: ['data'],
  data() {
    return {
      selectedArea: [],
      optType: null,
      drawBounds: '',
      areaId: null,
      areaName: '',
      areaBounds: [],
      oAreaBounds: '',
      personLimit: 0,
      areaType: 3,
      floorName: '',
      showPolygonSet: false,
      drawMarker: false,
      drawPoint: false,
      currentScene: {},
      currentSceneMap: '',
      imageBounds: [],
      bmap: null,
      markerClusterer: null,
      markerSet: {},
      infoBox: null,
      fences: [],
      clearFlag: true,
      points: [],
      close: false,
      openedInfoId: '',
      distance: '400px',
      checkFenceData: '',
      showFenceCheck: false,
      groupFences: [],
      groundOverlay: null,
      selectInNode: null,
      treeData: null,
      treeArrData: [],
      allSceneList: [],
      sceneMarker: [],
      switchLine: false,
      info: null,
      lineCoords: [],
      polylineCoords: [],
      currentSceneId: null,
      countMarker: null,
      totalCount: 0,
      areaList: [],
      drawnAreas: [],
      personStatistics: [],
      personStatisticsColumns: [
        {
          title: '区域名称',
          dataIndex: 'area',
          key: 'area',
        },
        {
          title: '人员数量',
          dataIndex: 'count',
          key: 'count',
        },
        {
          title: '结果',
          dataIndex: 'msg',
          key: 'msg',
          customRender: (text) => {
            if (Array.isArray(text)) {
              return (
                <div>
                  {text.map((item, index) => (
                    <div key={index}>{item}</div>
                  ))}
                </div>
              );
            }
            return text;
          }
        },
        
      ],
      showPersonStatistics: false,
    }
  },
  components: {
    ZInfoBox,
    CheckFenceGroup,
    SearchAddress,
    LeafPolygon
  },
  computed: {
    ...mapState({
      orgId: state => state.home.orgId,
      orgCoord: state => state.orgCoord
    })
  },
  methods: {
    // ...mapActions(['showFenceByOrgID']),
    // 显示机构的围栏
    showOrgFence() {
      console.log('show')
      // 1. 获取到当前机构的围栏 需要当前机构ID
      // console.log(this.orgId)
      // 2. 获取该机构的所有围栏
      httpModel.getOrgFenceById(this.orgId).then((res) => {
        console.log("显示机构的围栏", res)
        this.groupFencesData = res
        this.checkFenceData = res.map((group) => {
          return group.entityGroup.name
        })
        this.showFenceCheck = true
      })
    },
    onCheckOk(checkedList) {
      // 获取选择的围栏组
      let currentGroupFences = checkedList.map((name) => {
        let group = this.groupFencesData.find((group) => group.entityGroup.name === name)
        // console.log(group)
        let groupFence = group.ruleTemplate[0].fences
        return groupFence
      })
      // 画出围栏
      console.log(currentGroupFences)
      currentGroupFences.forEach((groupFence) => {
        if (groupFence.length > 0) {
          groupFence.forEach((fence) => {
            let fenceOverlays = drawFence(fence)
            // console.log(fenceOverlays)
            fenceOverlays.forEach((fenceOverlay) => {
              this.bmap.setViewport(fenceOverlay.getPath())
              this.groupFences.push(fenceOverlay)
              this.bmap.addOverlay(fenceOverlay)
            })
          })
        }
      })

      this.$nextTick().then(() => {
        this.showFenceCheck = false
      })
    },

    hideOrgFence() {
      this.groupFences.forEach((overlay) => {
        this.bmap.removeOverlay(overlay)
        this.groupFences = []
      })
    },
    // 显示所有marker标注的文本字
    showMarkerName() {
      // if (this)
      // console.log(this.markerSet)
      let markers = Object.keys(this.markerSet).map((key) => {
        return {
          id: key,
          marker: this.markerSet[key]
        }
      })
      markers.forEach((marker) => {
        let markerLabel = new BMap.Label(marker.marker.getTitle(), {
          offset: new BMap.Size(-10, -30)
        })
        markerLabel.setStyle(markerLabelStyle)
        marker.marker.setLabel(markerLabel)
      })
    },
    // 隐藏显示marker的label标注
    hideMarkerName() {
      // console.log(this.markerSet)
      let markers = Object.keys(this.markerSet).map((key) => {
        return {
          id: key,
          marker: this.markerSet[key]
        }
      })
      markers.forEach((marker) => {
        // let markerLabel = new BMap.Label('')
        let markerLabel = marker.marker.getLabel()
        markerLabel.setStyle({
          display: 'none'
        })
        marker.marker.setLabel(markerLabel)
      })
      // 这里让地图移动一下，不然设置不会生效
      this.bmap.panBy(0, 0)
    },
    onCloseDetail() {
      this.$emit("closeDetailPanel")
    },
    clearOverlay() {
      this.clearFences()
      // if (this.clearFlag) {
      //   this.clearFences()
      //   this.$emit("resetSelectedKey")
      // }
      this.$emit("closeDetailPanel")
      this.close = true
      this.openedInfoId = ''
    },
    clearFences() {
      let _this = this
      this.fences.forEach((fence) => {
        this.bmap.removeOverlay(fence)
      })
      this.fences = []
    },
    showFence(entityId) {
      this.clearFences()
      // console.log('cleared all fence')
      this.$http.get(config.api.get_personal_fence + entityId).then((response) => {
        if (response.code == 0) {
          if (response.result) {
            let _this = this
            response.result.map((fence) => {
              if (fence.coordType) {
                fence.parameter.points.forEach((pointsItem, i) => {
                  pointsItem.forEach((point, j) => {
                    let transedPoint = transToBD09(fence.coordType, point.lng, point.lat)
                    fence.parameter.points[i][j].lng = transedPoint.lng
                    fence.parameter.points[i][j].lat = transedPoint.lat
                  })
                })
                fence.coordType = 'bd09'
              }
              // debugger
              if (fence.type == 'circle') {
                let lat = fence.parameter.points[0][0].lat
                let lng = fence.parameter.points[0][0].lng
                let radius = fence.parameter.radius
                let overlay = new window.BMap.Circle(new window.BMap.Point(lng, lat), radius, fence.opt == 1 ? notAllowedInFenceStyle : notAllowedOutFenceStyle);
                _this.fences.push(overlay)
                _this.bmap.addOverlay(overlay)
              }
              if (fence.type == 'polygon') {
                let points = []
                fence.parameter.points[0].map(function (item) {
                  points.push(new window.BMap.Point(item.lng, item.lat))
                })
                let overlay = new window.BMap.Polygon(points, fence.opt == 1 ? notAllowedInFenceStyle : notAllowedOutFenceStyle);
                _this.fences.push(overlay)
                _this.bmap.addOverlay(overlay)
              }
              if (fence.type == 'district') {
                let points = []
                fence.parameter.points[0].map(function (item) {
                  points.push(new window.BMap.Point(item.lng, item.lat))
                })
                let overlay = new window.BMap.Polygon(points, fence.opt == 1 ? notAllowedInFenceStyle : notAllowedOutFenceStyle);
                _this.fences.push(overlay)
                _this.bmap.addOverlay(overlay)
              }
            })
            // console.log(this.fences)
            // console.log('drawed fence')
          }
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    openedInfoBoxId(id) {
      this.openedInfoId = id
    },
    handleIndoorLocation(data) {
      console.log('收到室内定位WebSocket消息:', data);
      if (!data || !data.data) return;

      const { entityId, data: positionData } = data;
      const { x, y, scene, address, timestamp, entity, onlineStatus } = positionData;

      if (!this.inMap || this.currentSceneId !== scene) {
        return;
      }

      const existingIndex = this.allSceneList.findIndex(item => item.id === entityId);
      if (existingIndex >= 0) {
        this.allSceneList[existingIndex] = {
          id: entityId,
          x: x,
          y: y,
          scene: scene,
          address: address,
          timestamp: timestamp,
          onlineStatus: onlineStatus,
          entity: entity || '未知'
        };
      } else {
        this.allSceneList.push({
          id: entityId,
          x: x,
          y: y,
          scene: scene,
          address: address,
          timestamp: timestamp,
          onlineStatus: onlineStatus,
          entity: entity || '未知'
        });
      }

      this.addMarkerse(this.allSceneList, scene);
      this.updateScene(this.allSceneList)
    },
    showTileLayer(info) {
      console.log("Map showTileLayer", info);
      if (info.type == 2) {
        this.currentScene = info
        this.currentSceneMap = 'https://zxsmart.cn' + info.map
        this.imageBounds = this.bdToArr(info.bounds)
        this.getAreaList(this.currentScene)
      }
      if (info.type < 2) {
        this.selectInNode = null;
        if (this.groundOverlay) this.bmap.removeOverlay(this.groundOverlay);
        let ad = this.bdToArr(info.data.geoBounds)
        // 西南角和东北角
        let num = this.transToBd09('gcj02', Number(ad[0][1]), Number(ad[0][0]))
        let num2 = this.transToBd09('gcj02', Number(ad[1][1]), Number(ad[1][0]))
        let SW = new window.BMap.Point(num[0], num[1]);
        let NE = new window.BMap.Point(num2[0], num2[1]);
        // console.log(SW, NE)
        let groundOverlayOptions = {
          opacity: 1,
          displayOnMinLevel: 10,
          displayOnMaxLevel: 20,
        }

        // 初始化GroundOverlay
        this.groundOverlay = new window.BMap.GroundOverlay(new window.BMap.Bounds(SW, NE), groundOverlayOptions);

        // 设置GroundOverlay的图片地址
        this.groundOverlay.setImageURL('https://zxsmart.cn' + info.data.map);
        this.bmap.addOverlay(this.groundOverlay);
        this.bmap.setViewport([SW, NE])
      } else {
        if (this.inMap && this.currentSceneId === info.id) {
          this.addMarkerse(this.allSceneList, info.id);
        } else {
          if (this.inMap) this.inMap.remove();
          this.sceneMarker = [];
          this.selectInNode = info;
          this.currentSceneId = info.id;

          setTimeout(() => {
            let map = L.map("areaMap", {
              minZoom: 1,
              maxZoom: 8,
              zoom: 6,
              crs: L.CRS.Simple,
              doubleClickZoom: false, // 禁用双击放大
              attributionControl: false, // 移除右下角leaflet标识
              zoomSnap: 0.1, //缩放倍数
              zoomControl: false,
            });
            this.inMap = map;
            let bounds = this.bdToArr(info.bounds)
            L.imageOverlay('https://zxsmart.cn' + info.map, bounds).addTo(this.inMap);
            map.fitBounds(bounds)
            //解算区域初始化
            // this.filterTree(this.treeData, info.name)
            if (this.treeArrData && this.treeArrData.length > 0 && this.treeArrData[0].children.length > 0) {
              this.treeArrData[0].children.forEach(item => {
                let bds = this.bdToArr(item.data.bounds)
                if (bds.length > 0)
                  var polygon = L.polygon(bds, { color: 'red', fill: false })
                polygon.addTo(this.inMap)
                // 中心名称
                let content = `<div style="
                        font-size:12px; 
                        white-space:nowrap; 
                        max-height:100%; 
                        display:flex;
                        justify-content: center;
                        align-items: center;
                        color: #000;
                        background: #fff;
                        border-radius: 2px;
                        padding: 0 3px;
                    ">
                    ${item.title}
                  </div>`;

                let markerIcon = L.divIcon({
                  html: content, //marker标注
                  className: "my-div-name-icon",
                  iconSize: [40, 40], //marker宽高
                });
                L.marker(
                  [polygon.getCenter().lat, polygon.getCenter().lng],
                  {
                    icon: markerIcon,
                  }
                ).addTo(map);
                polygon.remove();
              })

              //信标初始化
              let beacons = this.treeArrData[0].children[0].children.reduce((f, s) => f.concat(s.children), []);
              beacons.forEach(item => {
                this.buildBleMarker(item.data)
              })

            }


            //添加比例尺
            L.control.scale({ position: "bottomright", imperial: false }).addTo(this.inMap);
            // console.log("addMarkerse",this.allSceneList, info.id);

            // 添加点位
            this.addMarkerse(this.allSceneList, info.id);


            // console.log(allPoints, iconNormalImg)
            // 添加画线按钮
            var customButton = L.control({ position: 'topleft' });
            customButton.onAdd = function () {
              var btn = L.DomUtil.create('button', '', this._container);
              btn.innerHTML = '自定义按钮';
              console.log(btn)
              btn.onclick = function () {
                alert('按钮被点击！');
              };
              return this._container;
            };
            customButton.addTo(map);
          })
        }
      }
    },
    cancelModal() {
      if (this.inMap) this.inMap.remove();
      this.inMap = null;
      this.selectInNode = null;
      // this.switchLine = false;
      this.currentSceneId = null;
    },
    addMarkerse(data, id) {
      data.map(item => {
        if (item.scene == id) {
          const existingIndex = this.sceneMarker.findIndex(markerItem => markerItem.id === item.id);

          if (existingIndex >= 0) {
            const existingMarker = this.sceneMarker[existingIndex];
            existingMarker.marker.setLatLng([item.y, item.x]);

            // 更新图标（如果在线状态改变）
            if (existingMarker.onlineStatus !== item.onlineStatus) {
              let content = `<div style="position:relative;" >
                <div style="position:absolute;
                      font-size:12px; 
                      white-space:nowrap; 
                      max-height:100%; 
                      width:100%;
                      display:flex;
                      justify-content: center;
                      align-items: center;
                      top:-18px;
                      left:-0px;
                      color:#000;
                      ">${item.entity || ""}</div>
                <img src=${item.onlineStatus ? iconNormalImg : iconOfflineImg} style="width: 25px; height: 25px;">
                </div>`;

              let myIcon = L.divIcon({
                html: content, //marker标注
                className: 123,
                iconSize: [25, 25], //marker宽高
                iconAnchor: [12.5, 25], //文字标注相对位置
              });

              existingMarker.marker.setIcon(myIcon);
            }

            // 更新弹出框内容
            var popupContent = `
              <div class="person-info" style=" font-size:13px">
                <div class="info-box" style="padding: 15px;">
                  <div class="first" style="margin-bottom: 10px; font-size: 16px;">
                    <span>${item.entity || "--"}</span>
                  </div>
                  <div style="margin-bottom: 10px;">
                    <span>状态：${item.onlineStatus ? '在线' : '离线'}</span>
                    <i class="${item.onlineStatus ? 'icon-online icon-md' : 'icon-offline icon-md'}">
                      <zx-icon type="icon-shoubiao"></zx-icon>
                    </i>
                  </div>
                  <div style="margin-bottom: 10px; font-size: 14px;">
                    <span>位置：${item.address || "--"}</span>
                  </div>
                  <div style="font-size: 14px;">
                    <span>更新时间：${item.timestamp ? this.timeFormat(item.timestamp) : '未更新'}</span>
                  </div>
                </div>
                <div style="display: flex; background: #ccd5e3; height: 40px; line-height: 40px;">
                    <span style="color: #193777; cursor: pointer; width: 20%; text-align: center; display: inline-block; border-right: 1px solid #fff;" onclick="window.showDetailre('entity')">详情</span>
                    <span style="color: #193777; cursor: pointer; width: 20%; text-align: center; display: inline-block; border-right: 1px solid #fff;" onclick='window.showTrackre()'>轨迹</span>
                    <span style="color: #193777; cursor: pointer; width: 20%; text-align: center; display: inline-block; border-right: 1px solid #fff;" onclick="window.showDetailre('health')">健康</span>
                    <span style="color: #193777; cursor: pointer; width: 20%; text-align: center; display: inline-block; border-right: 1px solid #fff;" onclick="window.showDetailre('alarm')">告警</span>
                  </div>
              </div>`;

            existingMarker.marker.setPopupContent(popupContent);
            this.sceneMarker[existingIndex] = { marker: existingMarker.marker, id: item.id, x: item.x, y: item.y, timestamp: item.timestamp, onlineStatus: item.onlineStatus };
            if (this.info && this.info.id === item.id) {
              existingMarker.marker.openPopup();
            }
          } else {
            let content = `<div style="position:relative;" >
            <div style="position:absolute;
                  font-size:12px; 
                  white-space:nowrap; 
                  max-height:100%; 
                  width:100%;
                  display:flex;
                  justify-content: center;
                  align-items: center;
                  top:-18px;
                  left:-0px;
                  color:#000;
                  ">${item.entity || ""}</div>
            <img src=${item.onlineStatus ? iconNormalImg : iconOfflineImg} style="width: 25px; height: 25px;">
            </div>`;

            let myIcon = L.divIcon({
              html: content, //marker标注
              className: 123,
              iconSize: [25, 25], //marker宽高
              iconAnchor: [12.5, 25], //文字标注相对位置
            });

            var domMarker = L.Marker.movingMarker(
              [
                [item.y, item.x],
                [item.y, item.x],
              ],
              [],
              { autostart: true, loop: true, icon: myIcon }
            );
            domMarker.addTo(this.inMap);

            // 添加弹出框
            var popupContent = `
            <div class="person-info" style=" font-size:13px">
              <div class="info-box" style="padding: 15px;">
                <div class="first" style="margin-bottom: 10px; font-size: 16px;">
                  <span>${item.entity || "--"}</span> 
                </div>
                <div style="margin-bottom: 10px;">
                  <span>状态：${item.onlineStatus ? '在线' : '离线'}</span>
                  <i class="${item.onlineStatus ? 'icon-online icon-md' : 'icon-offline icon-md'}">
                    <zx-icon type="icon-shoubiao"></zx-icon>
                  </i>
                </div>
                <div style="margin-bottom: 10px; font-size: 14px;">
                  <span>位置：${item.address || "--"}</span>
                </div>
                <div style="font-size: 14px;">
                  <span>更新时间：${item.timestamp ? this.timeFormat(item.timestamp) : '未更新'}</span>
                </div>
              </div>
              <div style="display: flex; background: #ccd5e3; height: 40px; line-height: 40px;">
                  <span style="color: #193777; cursor: pointer; width: 20%; text-align: center; display: inline-block; border-right: 1px solid #fff;" onclick="window.showDetailre('entity')">详情</span>
                  <span style="color: #193777; cursor: pointer; width: 20%; text-align: center; display: inline-block; border-right: 1px solid #fff;" onclick='window.showTrackre()'>轨迹</span>
                  <span style="color: #193777; cursor: pointer; width: 20%; text-align: center; display: inline-block; border-right: 1px solid #fff;" onclick="window.showDetailre('health')">健康</span>
                  <span style="color: #193777; cursor: pointer; width: 20%; text-align: center; display: inline-block; border-right: 1px solid #fff;" onclick="window.showDetailre('alarm')">告警</span>
                </div>
            </div>`;

            // item.setPopupContent(popupContent);
            domMarker.bindPopup(popupContent, { offset: L.point(0, -45) });

            //点位点击事件
            domMarker.on("mousedown", () => {
              domMarker.off("click");
              domMarker.openPopup();
              this.info = item
            });
            if (this.info && this.info.id === item.id) {
              domMarker.openPopup();
            }
            this.sceneMarker.push({ marker: domMarker, id: item.id, x: item.x, y: item.y, timestamp: item.timestamp, onlineStatus: item.onlineStatus })
            if (this.switchLine && this.lineCoords.length > 1) {
              let secondlast = this.lineCoords.slice(-2)[0]
              let last = this.lineCoords[this.lineCoords.length - 1]
              let polyline = L.polyline([[secondlast[0], secondlast[1]], [last[0], last[1]]], {
                color: "red",
              }).addTo(this.inMap)
              this.polylineCoords.push(polyline)
            }
          }
        }
      })
    },
    timeFormat(timestamp) {
      return this.$moment(timestamp * 1000).format('YYYY/MM/DD HH:mm:ss')
    },
    filterTree(data, title) {
      // console.log("filterTree",data,title);
      // let arr = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].title == title) {
          this.treeArrData.push(data[i])
          break;
        } else if (data[i].children) {
          this.filterTree(data[i].children, title)
        }
      }
    },
    showTrackre() {
      this.$emit('showTrack', this.info)
    },
    showDetailre(type) {
      this.$emit('showDetail', this.info, type)
    },
    getTreeData(data) {
      console.log("Map getTreeData", data);
      this.treeData = data;
      this.treeArrData = []
    },
    // 获取区域列表
    getAreaList(scene) {   
      let params = {
        scene: scene.id,
      }
      this.$http.post(config.api.query_area_list, params).then(resp => {
        if (resp.code == 0) {
          this.areaList = resp.result
          this.drawArea()
        }
      })
    },
    // 绘制区域
    drawArea() {
      console.log("drawArea", this.areaList);
      this.drawnAreas.forEach(item => {
        if (item.area) this.inMap.removeLayer(item.area);
        if (item.marker) this.inMap.removeLayer(item.marker);
      });
      this.drawnAreas = [];
      
      this.areaList.map(item => {
        let area = L.polygon(this.bdToArrTwo(item.bounds), {
          color: "red",
        }).addTo(this.inMap)
        let content = `<div style="
                        font-size:12px; 
                        white-space:nowrap; 
                        max-height:100%; 
                        display:flex;
                        justify-content: center;
                        align-items: center;
                        color: #000;
                        background: #fff;
                        border-radius: 2px;
                        padding: 0 3px;
                    ">
                    ${item.name}
                  </div>`;

        let markerIcon = L.divIcon({
          html: content, //marker标注
          className: "my-div-name-icon",
          iconSize: [40, 40], //marker宽高
        });
        let areaMarker = L.marker(
          [area.getCenter().lat, area.getCenter().lng],
          {
            icon: markerIcon,
          }
        ).addTo(this.inMap);
        let tooltipContent = `
                    <div style="padding: 5px;">
                      <b style="display: block; text-align: center;">区域信息</b><br>
                      楼层名称: ${item.floorName || '未知'}<br>
                      区域名称: ${item.name || '未知'}<br>
                      人员限制: ${item.personLimit + '人' || '未知'}<br>
                      区域类型: ${item.type === 1 ? '禁入' : item.type === 2 ? '禁出' : '无出入限制'}<br> 
                    </div>
                  `;
        areaMarker.bindTooltip(tooltipContent, {
          direction: 'top',
          permanent: false,
          interactive: true,
          sticky: true,
          offset: [0, -25]
        });

        //点击事件
        areaMarker.on("click", () => {
          this.showAreaDetail(item)
        })
        this.drawnAreas.push({ area, marker: areaMarker });
      })
    },

    buildBleMarker(data) {
      //自定义点位结构
      let path = require("@/assets/images/lyxb2.png")
      let content = `<div style="position:relative;" >
                      <div style="position:absolute;
                           font-size:12px;
                           white-space:nowrap;
                           max-height:100%;
                           width:100%;
                           display:flex;
                           justify-content: center;
                           align-items: center;
                           top:-18px;
                           left:-0px;
                           color:#000;
                           ">${data.sn}</div>
                        <img src=${path} style="width: 22px; height: 22px;">
                     </div>`;
      let icon = L.divIcon({
        html: content, //marker标注
        className: 123,
        iconSize: [22, 22], //marker宽高
        iconAnchor: [11, 22], //文字标注相对位置
      });
      let marker = L.marker([data.y || 0, data.x || 0], {
        icon: icon,
      });

      marker.addTo(this.inMap)
    },
    bdToArr(va) {
      let sp = va.split(",")
      let arr = []
      sp.forEach(item => {
        let latLng = item.split("_")
        if (latLng.length == 2)
          arr.push(latLng)
      })
      return arr
    },

    bdToArrTwo(va) {
      let sp = va.split(",")
      let arr = []
      sp.forEach(item => {
        let latLng = item.split("_")
        if (latLng.length == 2)
          arr.push([latLng[1], latLng[0]])
      })
      return arr
    },
    // 获取所有室内定位点位
    getAllScene(data) {
      this.allSceneList = [];
      data.map(item => {
        if (item.scene && item.x && item.y) {
          this.allSceneList.push(item)
        }
      })
    },
    // 更新室内点位
    updateScene(data) {
      let updateData = data
      //更新点位
      // this.getAllScene(updateData)
      if (updateData.length > 0) {
        updateData.map(item => {
          if (item.scene && item.x && item.y) {
            this.sceneMarker.map(items => {
              if (!this.lineCoords.length) {
                this.lineCoords.push([items.y, items.x])
              }
              if (item.id == items.id) {
                items.marker.moveTo([item.y, item.x], 500)
                // 先更新数据模型中的坐标
                items.x = item.x;
                items.y = item.y;
                items.timestamp = item.timestamp;

                var popupContent = `
                  <div class="person-info" style=" font-size:13px">
                    <div class="info-box" style="padding: 15px;">
                      <div class="first" style="margin-bottom: 10px; font-size: 16px;">
                        <span>${item.entity || "--"}</span> 
                      </div>
                      <div style="margin-bottom: 10px;">
                        <span>状态：${item.onlineStatus ? '在线' : '离线'}</span>
                        <i class="${item.onlineStatus ? 'icon-online icon-md' : 'icon-offline icon-md'}">
                          <zx-icon type="icon-shoubiao"></zx-icon>
                        </i> 
                      </div>
                      <div style="margin-bottom: 10px; font-size: 14px;">
                        <span>位置：${item.address || "--"}</span>
                      </div>
                      <div style="font-size: 14px;">
                        <span>更新时间：${item.timestamp ? this.timeFormat(item.timestamp) : '未更新'}</span>
                      </div>
                    </div>
                    <div style="display: flex; background: #ccd5e3; height: 40px; line-height: 40px;">
                        <span style="color: #193777; cursor: pointer; width: 20%; text-align: center; display: inline-block; border-right: 1px solid #fff;" onclick="window.showDetailre('entity')">详情</span>
                        <span style="color: #193777; cursor: pointer; width: 20%; text-align: center; display: inline-block; border-right: 1px solid #fff;" onclick='window.showTrackre()'>轨迹</span>
                        <span style="color: #193777; cursor: pointer; width: 20%; text-align: center; display: inline-block; border-right: 1px solid #fff;" onclick="window.showDetailre('health')">健康</span>
                        <span style="color: #193777; cursor: pointer; width: 20%; text-align: center; display: inline-block; border-right: 1px solid #fff;" onclick="window.showDetailre('alarm')">告警</span>
                      </div>
                  </div>`;

                items.marker.getPopup().setContent(popupContent);

                // 先获取当前位置作为轨迹线的起点
                // let currentPos = [items.y, items.x]

                // 同时执行轨迹绘制和点位移动动画
                if (this.switchLine && this.inMap) {
                  // 添加新坐标到轨迹数组
                  this.lineCoords.push([item.y, item.x])
                  // 绘制轨迹线（从当前位置到新位置）
                  let secondlast = this.lineCoords.slice(-2)[0]
                  let last = this.lineCoords[this.lineCoords.length - 1]
                  let polyline = L.polyline([[secondlast[0], secondlast[1]], [last[0], last[1]]], {
                    color: "red",
                  }).addTo(this.inMap)
                  this.polylineCoords.push(polyline)
                }
              }
            })
          }
        })
      } else {
        this.sceneMarker.map(item => {
          if (item.onlineStatus) {
            console.log(this.$moment().unix())
            let t1 = item.timestamp
            let t2 = this.$moment().unix()

            let date1 = new Date(t1);
            let date2 = new Date(t2);

            let difference = date2 - date1;

            let differenceInThreeMinutes = difference / 180000

            if (differenceInThreeMinutes > 1) {
              item.marker.remove()
            }
          }
        })
      }
    },
    // 删除点位
    deleteSceneMarker() {

    },
    showAreaDetail(item) {
      console.log("showAreaDetail", item);
      this.showPolygonSet = true
      this.oAreaBounds = item.bounds
      this.areaBounds = this.bdToArrTwo(item.bounds)
      this.areaId = item.id
      this.areaName = item.name
      this.personLimit = item.personLimit
      this.areaType = item.type
      this.floorName = item.floorName
      this.optType = 2

    },
    handleLineBtn() {
      this.switchLine = !this.switchLine;

      // 只有在关闭画线时才清空轨迹
      if (!this.switchLine) {
        this.lineCoords = [];
        if (this.polylineCoords.length) {
          this.polylineCoords.map(item => {
            item.remove();
          });
          this.polylineCoords = [];
        }
      }
    },
    handleCountBtn() {
      this.showPolygonSet = true
      this.areaId = null
      this.areaName = ''
      this.personLimit = null
      this.areaType = null
      this.floorName = ''
      this.areaBounds = []
      this.optType = 1
    },
    handlePersonBtn(){
      let params = {
        scene: this.currentScene.id,
        areaIds: this.selectedArea
      }
      console.log(params)
      this.$http.post(config.api.person_statistics, params).then(res => {
        if (res.code === 0) {
          this.$message.success('人员统计查询成功') 
          this.personStatistics = res.result || []
          this.showPersonStatistics = true
        } else {
          this.$message.error(res.msg)
        }
      })

    },
    showInfo(info) {
      this.clearFences()
      if (this.markerSet[info.id]) {
        if (this.marker) {
          // this.marker.setZIndex(10000000000000)
          this.marker.setTop(true, 27000000)
        }
        this.marker = this.markerSet[info.id]
        let lnglat = this.transToBd09(info.coord_type, info.lng, info.lat)
        let point = new window.BMap.Point(lnglat[0], lnglat[1]);
        this.bmap.centerAndZoom(point, 18);
        this.clearFlag = true
        this.$refs["infoBox"].show(this.marker, info, this.bmap)
        this.showFence(info.id)
      } else {
        this.$refs["infoBox"].showInfo(info)
      }
    },
    showTrack(info) {
      this.$emit('showTrack', info)
    },
    showDetail(info, type) {
      this.$emit('showDetail', info, type)
    },
    addMarker(item) {
      // console.log(item)
      let lnglat = this.transToBd09(item.coord_type, item.lng, item.lat)
      let icon = this.getIcon(item)
      let point = new window.BMap.Point(lnglat[0], lnglat[1]);
      let iocUrl = new window.BMap.Icon(icon, new window.BMap.Size(29, 30), {
        anchor: new window.BMap.Size(10, 30)
      });
      let marker = new window.BMap.Marker(point, {
        icon: iocUrl,
        title: item.entity
      });
      this.markerSet[item.id] = marker
      let _this = this
      marker.addEventListener("click", _.throttle(function () {
        _this.clearOverlay()
        if (_this.marker) {
          _this.marker.setZIndex(100000000000000000)
        }
        _this.marker = marker
        // marker.setZIndex(200)
        let point = new window.BMap.Point(lnglat[0], lnglat[1]);
        _this.bmap.centerAndZoom(point, _this.bmap.getZoom());
        _this.$emit("setSelectedRowKey", item.id)
        _this.showFence(item.id)
        _this.clearFlag = true
        _this.$refs["infoBox"].show(marker, item, _this.bmap)
      }, 3000, { leading: true }));
      marker.setZIndex(100000000000000000)
      _this.markerClusterer.addMarker(marker)
    },
    deleteMarker(item) {
      if (this.markerSet[item.id]) {
        this.markerClusterer.removeMarker(this.markerSet[item.id])
        delete this.markerSet[item.id]
      }
    },
    setMarker(item) {
      if (!this.markerSet[item.id]) {
        this.addMarker(item)
      } else {
        // console.log(item)
        let lnglat = this.transToBd09(item.coord_type, item.lng, item.lat)
        let marker = this.markerSet[item.id]
        let icon = this.getIcon(item)
        marker.setIcon(icon)

        let point = new window.BMap.Point(lnglat[0], lnglat[1]);
        marker.setPosition(point)
        // 如果是当前打开的infobox，就更新infobox的位置
        if (this.openedInfoId && item.id == this.openedInfoId) {
          this.$nextTick().then(() => {
            console.log('fresh')
            // 地图视野刷新
            this.bmap.centerAndZoom(point, 18)
            // 内容刷新
            this.$refs['infoBox'].freshInfoBox(point)
            this.showInfo(item)
          })
          // debugger
        }
        //let _this = this
        /*
        marker.addEventListener("click", function () {
            _this.clearFences()
            _this.marker = marker
            let point = new window.BMap.Point(lnglat[0], lnglat[1]);
            _this.bmap.centerAndZoom(point,_this.bmap.getZoom());
            _this.$refs["infoBox"].show(marker,item,_this.bmap)
        });
        */
      }
    },
    refreshAll(data) {
      // this.getAllScene(data)

      this.markerSet = {}
      let _this = this
      let points = []

      this.markerClusterer.clearMarkers();
      data.map(function (item) {
        if (item.lat && item.lng) {
          let lnglat = _this.transToBd09(item.coord_type, item.lng, item.lat)
          console.log(lnglat)
          let icon = _this.getIcon(item)
          let point = new window.BMap.Point(lnglat[0], lnglat[1]);
          let iocUrl = new window.BMap.Icon(icon, new window.BMap.Size(29, 30), {
            anchor: new window.BMap.Size(10, 30)
          });
          let marker = new window.BMap.Marker(point, {
            icon: iocUrl,
            title: item.entity
          });
          marker.setZIndex(1000000)
          _this.markerSet[item.id] = marker
          marker.addEventListener("click", _.throttle(function () {
            _this.clearOverlay()
            if (_this.marker) {
              // _this.marker.setZIndex(100)
            }
            _this.marker = marker
            marker.setZIndex(1000000)
            // marker.setTop(true)
            let point = new window.BMap.Point(lnglat[0], lnglat[1]);
            _this.bmap.centerAndZoom(point, _this.bmap.getZoom());
            _this.$emit("setSelectedRowKey", item.id)
            _this.showFence(item.id)
            _this.clearFlag = true
            _this.$refs["infoBox"].show(marker, item, _this.bmap)
          }, 3000, { leading: true }));
          _this.markerClusterer.addMarker(marker)
          points.push(point)
          _this.points = points
        }
      })
      _this.bmap.setViewport(points)
    },
    getIcon(item) {
      if (item.onlineStatus) {
        if (item.alarmNum && item.alarmNum > 0) {
          return iconAlarmImg
        } else {
          return iconNormalImg
        }
      } else {
        if (item.alarmNum && item.alarmNum > 0) {
          return iconOfflineAlarmImg
        } else {
          return iconOfflineImg
        }
      }
    },
    transToBd09(coord_type, lng, lat) {
      var tmpLat = +lat;
      var tmpLng = +lng;
      var tmp;
      // console.log(lng, lat)
      if (coord_type == 'wgs84' || coord_type == 'WGS84') {
        tmp = TransForm.wgs84tobd09(tmpLng, tmpLat);
        // console.log(tmp)
      } else if (coord_type == 'gcj02' || coord_type == 'GCJ02') {
        tmp = TransForm.gcj02tobd09(tmpLng, tmpLat);
      } else {
        tmp = [tmpLng, tmpLat];
      }
      tmp = [tmp[0].toFixed(6), tmp[1].toFixed(6)];
      return tmp;
    },
    addNavigationControl() {
      let navigationControl = new window.BMap.NavigationControl({
        anchor: window.BMAP_ANCHOR_TOP_LEFT,
        type: window.BMAP_NAVIGATION_CONTROL_ZOOM,
        offset: new window.BMap.Size(22, 200),
        showZoomInfo: true
      });
      this.bmap.addControl(navigationControl);
    },
    addMapTypeController() {
      let offset = new window.BMap.Size(18, 40);
      let mapTypeControl = new window.BMap.MapTypeControl({
        mapTypes: [window.BMAP_NORMAL_MAP, window.BMAP_HYBRID_MAP],
        anchor: window.BMAP_ANCHOR_TOP_LEFT,
        offset: offset
      });
      this.bmap.addControl(mapTypeControl);
    },
    addGeolocationControl() {
      let geolocationControl = new window.BMap.GeolocationControl({
        anchor: window.BMAP_ANCHOR_TOP_LEFT,
        type: window.BMAP_NAVIGATION_CONTROL_ZOOM,
        size: new window.BMap.Size(30, 30),
        offset: new window.BMap.Size(22, 438)
      })
      this.bmap.addControl(geolocationControl);
    },
    addCityListControl() {
      let size = new window.BMap.Size(30, 20);
      this.cityListControl = new window.BMap.CityListControl({
        anchor: window.BMAP_ANCHOR_TOP_LEFT,
        offset: size
      })
      this.bmap.addControl(this.cityListControl);
    },
    // 添加一个自定义控件，返回地图初始位置
    addMapInitControl() {
      // console.log(this.points)
      let myMapInitControl = new MapInitControl({
        anchor: window.BMAP_ANCHOR_TOP_LEFT,
        offset: new window.BMap.Size(22, 80)
      })
      this.myMapInitControl = myMapInitControl
      this.bmap.addControl(myMapInitControl)
    },
    addMarkerLabelControl() {
      let myMarkerLabelControl = new MarkerLabelControl({
        anchor: window.BMAP_ANCHOR_TOP_LEFT,
        offset: new window.BMap.Size(22, 120)
      })
      this.myMarkerLabelControl = myMarkerLabelControl
      this.bmap.addControl(myMarkerLabelControl)
    },
    addOrgFenceControl() {
      let myOrgFenceControl = new OrgFenceControl({
        anchor: window.BMAP_ANCHOR_TOP_LEFT,
        offset: new window.BMap.Size(22, 160)
      })
      this.myOrgFenceControl = myOrgFenceControl
      this.bmap.addControl(myOrgFenceControl)
    },
    // 获取所有设备点坐标
    getAllPoints() {
      // 确保实体数据存在
      if (this.data.length > 0) {
        // 筛选出有坐标点和坐标系的实体数据
        let curData = this.data.filter((entity) => {
          return entity.coord_type && entity.lat && entity.lng
        })
        // 有坐标的实体数据存在
        if (curData.length > 0) {
          // console.log(curData)
          // 转换坐标之后生成点数组
          let points = curData.map((item) => {
            let coord = this.transToBd09(item.coord_type, item.lng, item.lat)
            let point = new BMap.Point(coord[0], coord[1])
            // console.log(point)
            return point
          })
          // console.log(points)
          return points
        }
      }

    },
    removeCityList() {
      this.bmap.removeControl(this.cityListControl);
    },
    init() {
      this.bmap = new window.BMap.Map("homeMap", {
        // enableAutoResize: false,
        // enableMapClick: false
        maxZoom: 22
      });
      // this.bmap.centerAndZoom(new window.BMap.Point(116.404, 39.915), 12);
      this.bmap.centerAndZoom(new window.BMap.Point(this.orgCoord.point.lng, this.orgCoord.point.lat), this.orgCoord.zoom)
      this.bmap.enableScrollWheelZoom(true);
      this.addNavigationControl()
      this.addMapTypeController()
      // this.addGeolocationControl()
      // this.addCityListControl()
      this.addMapInitControl()
      this.addMarkerLabelControl()
      // !this.myOrgFenceControl && this.addOrgFenceControl()
      console.log(this.myOrgFenceControl)
      if (!this.myOrgFenceControl) {
        this.addOrgFenceControl()
      }
      this.markerClusterer = new MarkerClusterer(this.bmap, {
        markers: []
      });
      let _this = this
      this.bmap.addEventListener("zoomstart", () => {
        this.clearFlag = false
        // this.clearFences()
        // this.$refs["infoBox"].closeInfoBox()
      });
    },
    delArea(){
      this.$http.delete(config.api.delete_area + "?id=" + this.areaId,
      ).then((res) => {
        if (res.code === 0) {
          this.$notification.success({
            message: '区域删除成功'
          })
          this.getAreaList(this.currentScene)
          this.closePolygonSet()
        } else {
          this.$notification.error({
            message: `${res.desc}`
          })
        }
      })
    },
    getPolygonMsg(msg, areaName, personLimit, areaType, floorName) {
      console.log("getPolygonMsg", msg, areaName, personLimit, areaType, floorName)
      if (msg) {
        if (this.drawMarker) {

        } else if (this.drawPoint) {
          let bounds = msg.map(m =>
            m.lng.toFixed(2)
            + "_"
            + m.lat.toFixed(2)
          ).join(",")

        } else {
          let bounds = msg.map(m =>
            m.lng.toFixed(2)
            + "_"
            + m.lat.toFixed(2)
          ).join(",")
          if (bounds) {
            this.drawBounds = bounds
          }
        }
      }else{
        this.drawBounds = ''
      }

      this.areaName = areaName
      this.personLimit = personLimit
      this.areaType = areaType
      this.floorName = floorName
      this.showPolygonSet = false
      if (!areaName && !personLimit && !areaType) {
        this.areaId = null
        this.areaBounds = []
        this.oAreaBounds = ''
        this.floorName = ''
      } else {
        this.saveOrUpdateArea(this.drawBounds ? this.drawBounds : this.oAreaBounds)
      }
    },
    saveOrUpdateArea(bounds) {
      const formData = {
        name: this.areaName,
        personLimit: this.personLimit,
        scene: this.currentScene.id,
        bounds: bounds,
        type: this.areaType,
        floorName: this.floorName,
      }
      if (this.areaId) {
        formData.id = this.areaId
        this.$http.post(config.api.update_area, formData).then((res) => {
          if (res.code === 0) {
            this.$notification.success({
              message: '区域更新成功'
            })
            this.getAreaList(this.currentScene)
            this.closePolygonSet()
          } else {
            this.$notification.error({
              message: `${res.desc}`
            })
          }
        })
      } else {
        this.$http.post(config.api.save_area, formData).then((res) => {
          if (res.code === 0) {
            this.$notification.success({
              message: '区域保存成功'
            })
            this.getAreaList(this.currentScene)
            this.closePolygonSet()
          } else {
            this.$notification.error({
              message: `${res.desc}`
            })
          }
        })
      }
    },
    closePolygonSet() {
      this.showPolygonSet = false
      this.areaId = null
      this.areaName = ''
      this.personLimit = null
      this.areaType = null
      this.areaBounds = []
      this.oAreaBounds = ''
    },
    handleSelectChange(val) {
      console.log(val)
      this.selectedArea = val
    }
  },
  mounted() {
    this.init()
    window.showDetailre = this.showDetailre
    window.showTrackre = this.showTrackre

    // let _this = this
    // setTimeout(() => {
    //   this.bmap.addEventListener('click', (ev) => {
    //     console.log(ev)
    //     this.transToBd09('wgs84', ev.point.lng, ev.point.lat)
    //   })
    // }, 1000)
    // bus.$on('MapDestroy', () => {
    //   this.addCityListControl()
    // })
    bus.$on('showMapTrack', () => {
      this.removeCityList()
    })
    bus.$on('langChanged', (lang) => {
      this.myMapInitControl && this.myMapInitControl.setText()
      this.myMarkerLabelControl && this.myMarkerLabelControl.setText()
      this.myOrgFenceControl && this.myOrgFenceControl.setText()
    })
    // 触发回到中心点事件
    bus.$on('setViewport', () => {
      // console.log('i get')
      // console.log(this.data)
      let points = this.getAllPoints()
      points.length > 0 && this.bmap.setViewport(points)
    })
    bus.$on('onDrawerChange', (data) => {
      if (data) {
        this.distance = '400px'
      } else {
        this.distance = '50px'
      }
    })
    // 显示infobox
    bus.$on('showInfoBox', (record) => {
      this.showInfo(record)
    })
    // 隐藏实体图标上的名称显示
    bus.$on('hideMarkerName', () => {
      this.hideMarkerName()
    })
    // 在实体图标上显示实体名称
    bus.$on('showMarkerName', () => {
      // console.log('show marker')
      this.showMarkerName()
    })
    // 隐藏当前机构的围栏
    bus.$on('hideOrgFence', () => {
      // console.log('hide fence')
      this.hideOrgFence()
    })
    // 显示当前机构围栏
    bus.$on('showOrgFence', () => {
      // console.log(this.$lodash)
      // console.log('show fence')
      this.showOrgFence()
    })
    // bus.$on('showOrgFence', this.$lodash.debounce(this.showOrgFence, 1000, {leading: true}))
  },
  sockets: {
    connect() {
      console.log('IndoorLocation WebSocket 连接成功');
    },
    disconnect() {
      console.log('IndoorLocation WebSocket 连接断开');
    },
    indoorLocationEvent(data) {
      this.handleIndoorLocation(data);
    }
  },
  beforeDestroy() {
    // console.log('before')
    bus.$off("showInfoBox")
    bus.$off("showMarkerName")
    bus.$off("hideMarkerName")
    bus.$off("showOrgFence")
    bus.$off("hideOrgFence")
    bus.$off('onDrawerChange')
    bus.$off('showMapTrack')
    bus.$off('setViewport')
    bus.$off('MapDestroy')
    bus.$off('langChanged')
    // console.log(this.myOrgFenceControl)
    // this.$socket.emit('destroyed', this.$store.getters.token);
    // this.myOrgFenceControl && this.bmap.removeControl(this.myOrgFenceControl)
    // this.myOrgFenceControl && this.myOrgFenceControl.removeHandler()
  },
  destroyed() {
    // console.log('over')
    // console.log(this.myOrgFenceControl)
  }
}
</script>

<style lang="less" scoped>
@import '../../theme/color.less';

.home-map {
  position: absolute;
  right: 0;
}

.area-map-border {
  position: absolute;
  // top: 100px;
  left: 450px;
  bottom: 100px;
  z-index: 999;
  padding: 3px;
  border-radius: 10px;
  // background: #FFE6B0;
  width: 75%;
  height: 80vh;
}

.area-map {
  width: 100%;
  height: 100%;
  // background: rgba(209, 213, 209, 0.99);
  background-image: url('../../assets/images/bg.png');
  background-size: cover;
  border-radius: 10px;
}

.cancelBtn {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}

/deep/ .my-div-name-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .my-div-name-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

#custom-button-line {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 999;
}

#custom-button-count {
  position: absolute;
  top: 10px;
  left: 110px;
  z-index: 999;
}

#custom-select-person {
  position: absolute;
  top: 10px;
  left: 210px;
  z-index: 999;
  width: 200px;
}

#custom-button-person {
  position: absolute;
  top: 10px;
  left: 410px;
  z-index: 999;
}

.icon-online {
  color: @primary-color;
}

.icon-offline {
  color: @disabled-color;
}

.icon-lg {
  font-size: 1.3rem;
}

.icon-md {
  font-size: 1.1rem;
}

/deep/.leaflet-popup-content-wrapper {
  width: 280px;
  height: auto;
  overflow: hidden;
}

/deep/.leaflet-popup-content {
  width: 100% !important;
  margin: 0;
}

/deep/[style*="z-index: 500"] {
  z-index: 400 !important;
}
</style>
